"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _Backdrop = _interopRequireDefault(require("@material-ui/core/Backdrop"));

var _Button = _interopRequireDefault(require("@material-ui/core/Button"));

var _Box = _interopRequireDefault(require("@material-ui/core/Box"));

var _Grid = _interopRequireDefault(require("@material-ui/core/Grid"));

var _cookieConsentStyles = require("../styles/cookie-consent-styles");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr && (typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]); if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var CHECKPOINT_DATE = new Date(2020, 11, 1);
var COOKIES_POLICY_KEY = "_cookies_";
var DATE_FORMAT = {
  "dateStyle": "medium",
  "timeStyle": "long"
};

var archiveCookiePolicy = function archiveCookiePolicy() {
  localStorage.setItem(COOKIES_POLICY_KEY, Date().toLocaleString("en-US", DATE_FORMAT));
};

var fetchCookiePolicy = function fetchCookiePolicy() {
  return localStorage.getItem(COOKIES_POLICY_KEY);
};

var CookieConsent = function CookieConsent() {
  var classes = (0, _cookieConsentStyles.useStyles)();

  var _React$useState = _react.default.useState(true),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      open = _React$useState2[0],
      setOpen = _React$useState2[1];

  var handleClose = function handleClose() {
    archiveCookiePolicy();
    setOpen(false);
  };

  (0, _react.useEffect)(function () {
    var cookiesPolicy = fetchCookiePolicy();
    var isCookiesAccepted = cookiesPolicy != null && new Date(cookiesPolicy) > CHECKPOINT_DATE;
    setOpen(!isCookiesAccepted);
  }, []);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_Backdrop.default, {
    className: classes.backdrop,
    open: open
  }, /*#__PURE__*/_react.default.createElement(_Grid.default, {
    container: true,
    className: classes.messageBox
  }, /*#__PURE__*/_react.default.createElement(_Grid.default, {
    item: true,
    xs: 10,
    className: classes.messageBoxText
  }, "We use cookies to optimize the use of this website for you and continuously update it according to your needs. Please click on \"Cookies\" in your browser settings for detailed information on the use of cookies on this website. If you click \"Yes, I agree\", cookies will be activated.\xA0", /*#__PURE__*/_react.default.createElement("a", {
    href: "https://jnpsoft.com/privacy-policy-of-jnpsoft/",
    target: "_blank",
    rel: "noopener noreferrer"
  }, "Learn More")), /*#__PURE__*/_react.default.createElement(_Grid.default, {
    item: true,
    xs: 2
  }, /*#__PURE__*/_react.default.createElement(_Button.default, {
    className: classes.btnAgree,
    onClick: handleClose
  }, "Yes, I Agree")))));
};

var _default = CookieConsent;
exports.default = _default;